// cryptoUtils.js
// AES decryption utility for document download URLs using crypto-js

import CryptoJS from 'crypto-js';

// === Get encryption constants from environment variables ===
// Make sure these exist in your .env.local or window.epAppData
const AES_PASSWORD = process.env.REACT_APP_AES_PASSWORD || "earthisthe3rdplanetinsolarsystem";
const AES_SALT = process.env.REACT_APP_AES_SALT || "hardcorepakour!!";
const AES_IV = process.env.REACT_APP_AES_IV || "tobeortonottobe!";

// === Validate constants ===
if (!AES_PASSWORD || !AES_SALT || !AES_IV) {
  throw new Error(
    'Missing required AES configuration: REACT_APP_AES_PASSWORD, REACT_APP_AES_SALT, REACT_APP_AES_IV.'
  );
}

/**
 * Derive AES key using PBKDF2 (SHA256, 10000 iterations)
 */
function deriveKey() {
  const password = CryptoJS.enc.Utf8.parse(AES_PASSWORD);
  const salt = CryptoJS.enc.Utf8.parse(AES_SALT);

  return CryptoJS.PBKDF2(password, salt, {
    keySize: 256 / 32,
    iterations: 1000,
    hasher: CryptoJS.algo.SHA256,
  });
}

/**
 * Decrypt AES encrypted data (Base64) from backend (Python)
 */
export function decryptAES(encryptedData) {
  try {
    const iv = CryptoJS.enc.Utf8.parse(AES_IV);
    const key = deriveKey();

    // Decode Base64 ciphertext
    const ciphertext = CryptoJS.enc.Base64.parse(encryptedData);

    // AES decrypt
    const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);

    if (!decryptedString) {
      throw new Error('Decryption failed: Malformed UTF-8 data');
    }

    return decryptedString;

  } catch (error) {
    console.error('Decryption failed:', error);
    throw new Error('Failed to decrypt data');
  }
}

/**
 * Decrypt document download URL
 */
export function decryptDocumentUrl(encryptedUrl) {
  try {
    return decryptAES(encryptedUrl);
  } catch (error) {
    console.error('Failed to decrypt document URL:', error);
    throw error;
  }
}


